import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M10.7 6.85a.7.7 0 1 0-1.4 0v4.2a.7.7 0 1 0 1.4 0zm-.619 5.955-.082-.005-.076.004A.699.699 0 0 0 10 14.2a.7.7 0 0 0 .081-1.395"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.327 3.578c.37-.37.872-.578 1.396-.578h4.553c.524 0 1.026.208 1.396.578l2.749 2.749c.37.37.579.874.579 1.398v4.552c0 .523-.209 1.025-.577 1.394l-2.75 2.75c-.37.37-.872.579-1.396.579H7.723a1.97 1.97 0 0 1-1.396-.578l-2.749-2.749A1.98 1.98 0 0 1 3 12.277V7.723c0-.524.208-1.026.578-1.396zM10 6.15a.7.7 0 0 1 .7.7v4.2a.7.7 0 1 1-1.4 0v-4.2a.7.7 0 0 1 .7-.7m0 6.65.081.005a.7.7 0 1 1-.158 0z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AlertErrorFilledIcon20.js.map